import React from "react";
import { Tag } from "@design-system/Tag/Tag";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { RULE_TAG_PROPS } from "./ruleTagUtils";
import layoutStyles from "./RuleTagLayout.module.scss";

interface RuleTagRowProps {
    label: string;
    type: "condition" | "action";
    values?: string[];
    children?: React.ReactNode;
}

export const RuleTagRow: React.FC<RuleTagRowProps> = ({
    label,
    type,
    values,
    children,
}) => {
    if (!children && !values?.length) {
        return null;
    }

    const labelClassName =
        type === "condition"
            ? layoutStyles.conditionLabel
            : layoutStyles.actionLabel;

    return (
        <>
            <span className={labelClassName}>{label}</span>
            <span className={layoutStyles.values}>
                {children ?? <TagValues values={values!} />}
            </span>
        </>
    );
};

const TagValues: React.FC<{ values: string[] }> = ({ values }) => {
    if (values.length === 1) {
        return (
            <Tag {...RULE_TAG_PROPS}>
                <BreakableText text={values[0]} showTooltip />
            </Tag>
        );
    }

    const [first, ...rest] = values;

    return (
        <>
            <Tag {...RULE_TAG_PROPS}>
                <BreakableText text={first} showTooltip />
            </Tag>
            <Tooltip content={rest.join(", ")}>
                <span>
                    <Tag {...RULE_TAG_PROPS} numeric>
                        + {rest.length}
                    </Tag>
                </span>
            </Tooltip>
        </>
    );
};
